import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormValueReadableValue
} from "../../../../type-handler/abstract-field-input-type-handler.component";
import {FormBuilder, FormGroup, UntypedFormControl} from "@angular/forms";
import {
  FormDefinitionFieldModel
} from "../../../../../../../../modules/form/definition/field/api/entity/formDefinitionField.model";
import {FormValueModel} from "../../../../../../../../modules/form/form/value/api/entity/formValue.model";
import {
  DrawingOnImageComponent, DrawingOptions
} from "../../../../../../../../modules/common/drawing/drawing-on-image/drawing-on-image.component";
import {Base64Utils} from "../../../../../../../../modules/core/utils/base64.utils";
import {
  DrawableImageV2FieldInputTypeHandlerComponentUtils
} from "../drawableImageV2FieldInputTypeHandlerComponent.utils";
import {AbstractDrawableImageV2InputTypeHandler} from "../AbstractDrawableImageV2InputTypeHandler";


@Component({
  selector: 'app-drawable-image-v2-field-input-type-handler',
  standalone: true,
  imports: [CommonModule, DrawingOnImageComponent],
  templateUrl: './drawable-image-v2-field-input-type-handler.component.html',
  styles: [
  ]
})
export class DrawableImageV2FieldInputTypeHandlerComponent extends AbstractDrawableImageV2InputTypeHandler
implements OnDestroy, AfterViewInit {

  initDone = false;
  imageUrl: string;
  options: DrawingOptions;
  drawingData: any = {items: []}

  public static resolveReadableValues(value: any): Promise<FormValueReadableValue[]> {
    return DrawableImageV2FieldInputTypeHandlerComponentUtils.resolveReadableValues(value);
  }


  constructor(private formBuilder: FormBuilder) {
    super();
  }

  ngAfterViewInit(): void {
  }



  buildJsonControl(formDefinitionField: FormDefinitionFieldModel): FormGroup {
    const data = JSON.parse(formDefinitionField.data);
    this.options = {
      options: data.options
    }
    if (data.image) {
      this.imageUrl = URL.createObjectURL(Base64Utils.base64ToBlob(data.image));
    }

    return this.formBuilder.group({
        image: this.formBuilder.control(undefined),
        data: this.formBuilder.control(undefined),
      });
  }

  initiateForm(formValue: FormValueModel): void {
    const value = formValue.value;
    if (value) {
      const parsed = JSON.parse(value);
      if (parsed.data?.items) {
        this.drawingData.items = parsed.data.items.map(value => {
          return {
            typeValue: value.typeValue,
            subTypeValue: value.subTypeValue,
            common: value.common,
            properties: value.properties
          }
        });
      }
    }
    this.initDone = true;
  }

  synchronizeValue(): string {
    return JSON.stringify(this.jsonControl.value);
  }
}
